import { render, staticRenderFns } from "./ImportCompanyAccess.vue?vue&type=template&id=143f9d93&scoped=true&"
import script from "./ImportCompanyAccess.vue?vue&type=script&lang=js&"
export * from "./ImportCompanyAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f9d93",
  null
  
)

export default component.exports